export const GET_BRANCHES = "get_branches";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const GET_BARETER_PLANS = "get_bareter_plans";
export const GET_SUMMARY = "get_summary";
export const GET_CONSULTANTS = "get_consultant";
export const GET_CONSULTANTS_PDF = "get_consultant_pdf";
export const ERROR = "error";
